exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gravatar-pic[data-v-ea55bdd4]{border-radius:50%;width:100px;display:initial;margin-bottom:6px}", ""]);

// exports
